interface IRouteUrlListElement {
    name: string;
    path: string;
    stepNum?: PageNavSteps | null | undefined; // 步驟數
    // loadDataRequired?: boolean | null | undefined; // 該頁面加載後是否會打api，載入歷史資料(每個api request前都會檢查伺服器停登訊息)
    requiredLogin?: boolean | null | undefined; // 登入檢查
    leaveProtection?: boolean | null | undefined; // 離開提示
}

enum PageNavSteps {
    BusinessSelection = 1, // 選擇補件業務
    FileUpload = 2, // 上傳補件檔案
    Complete = 3 // 完成補件
}

interface IRouteUrlList {
    [key: string]: IRouteUrlListElement;
}
interface IBaseSite {
    API_ServiceAlert: IRouteUrlListElement;
    API_ConfirmIdleAlert: IRouteUrlListElement;
    API_IdleTimeout: IRouteUrlListElement;
    API_ConfirmServiceAlert: IRouteUrlListElement;
    API_CheckIfLogin: IRouteUrlListElement;
    API_Logout: IRouteUrlListElement;

    Index: IRouteUrlListElement;

    StateError: IRouteUrlListElement;
    API_StateErrorViewData: IRouteUrlListElement;
}
interface ILogin {
    Login: IRouteUrlListElement;
    Captcha: IRouteUrlListElement;
    API_CheckBid: IRouteUrlListElement;

    API_LoginViewData: IRouteUrlListElement;
    API_LoginPostBack: IRouteUrlListElement;
    API_LoginQueryMobile: IRouteUrlListElement;
    API_SendSmsOtp: IRouteUrlListElement;
    API_VerifyMobile: IRouteUrlListElement;
}

interface IDCS {
    // 補件平台 - 無補件項目
    NoItem: IRouteUrlListElement;

    // 補件平台 - 全部完成
    AllComplete: IRouteUrlListElement;

    // 補件平台 - 選擇補件業務
    BusinessSelection: IRouteUrlListElement;
    API_BusinessSelectionViewData: IRouteUrlListElement;
    API_BusinessSelectionPostBack: IRouteUrlListElement;

    // 補件平台 - 檔案上傳
    FileUpload: IRouteUrlListElement;
    // 更新已上傳檔案
    API_FileUploadViewData: IRouteUrlListElement;

    // 更新QR Code
    API_GenerateToken: IRouteUrlListElement;

    // 客戶上傳單一檔案  (身分證正面以外的一般文件)
    API_ClientUploadSingleFile: IRouteUrlListElement;

    // 客戶上傳身分證正面文件 (OCR換補領資訊)
    API_ClientUploadIdFrontFile: IRouteUrlListElement;

    // 圖片預覽 - 透過 DocumentID 取得檔案 Base64
    API_ImagePreview: IRouteUrlListElement;

    // 完成上傳
    API_CompleteDocumentCase: IRouteUrlListElement;

    // 取消上傳中的案件
    API_CancelUploading: IRouteUrlListElement;

    // 刪除已上傳的檔案
    API_DeleteUploadedFile: IRouteUrlListElement;

    // 集保(TDCC) 取得 TxID
    API_TdccGetTXID: IRouteUrlListElement;

    // 集保(TDCC) 取消授權
    API_TdccRemoveTxID: IRouteUrlListElement;

    // 補件平台 - 完成補件
    CompleteUploading: IRouteUrlListElement;
}

interface IDcsRouteList extends IRouteUrlList, IBaseSite, ILogin, IDCS {}

const RouteUrlList: IDcsRouteList = {
    API_ServiceAlert: { name: 'API_ServiceAlert', path: '/api/Base/ServiceAlert' }, // 1.初始化/刷新 session cookie 、 XSRF cookie 2.取得停登訊息
    API_ConfirmIdleAlert: { name: 'API_ConfirmIdleAlert', path: '/api/Base/ConfirmIdleAlert' }, // 延展 session idle timeout
    API_IdleTimeout: { name: 'API_IdleTimeout', path: '/api/Base/IdleTimeout' }, // 前端逾時轉導 redirect action/
    API_ConfirmServiceAlert: {
        name: 'API_ConfirmServiceAlert',
        path: '/api/Base/ConfirmServiceAlert'
    }, // 確認閱讀 停止登入 訊息
    API_CheckIfLogin: { name: 'API_CheckIfLogin', path: '/api/Login/Check' }, // 檢查是否登入
    API_Logout: { name: 'API_Logout', path: '/api/Logout' }, // 登出

    Index: { name: 'Index', path: '/', requiredLogin: false, leaveProtection: false }, // Index頁
    Login: { name: 'Login', path: '/Login', requiredLogin: false, leaveProtection: false }, // 登入頁
    Captcha: { name: 'Captcha', path: '/api/Captcha', requiredLogin: false, leaveProtection: false }, // Captcha
    API_CheckBid: { name: 'API_CheckBid', path: '/api/Login/CheckBid' }, // 登入頁 檢查單一分公司
    API_LoginViewData: { name: 'API_LoginViewData', path: '/api/Login/ViewData' }, // 登入頁 View Data Api
    API_LoginPostBack: { name: 'API_LoginPostBack', path: '/api/Login/PostBack' }, // 登入
    API_LoginQueryMobile: { name: 'API_LoginQueryMobile', path: '/api/Login/QueryMobile' }, // 手機號碼查詢及發送 OTP 簡訊
    API_VerifyMobile: { name: 'API_VerifyMobile', path: '/api/Login/VerifyMobile' }, // 驗證手機 OTP 簡訊驗證碼
    API_SendSmsOtp: { name: 'API_SendSmsOtp', path: '/api/Login/SendSmsOtp' }, // 重新發送 OTP 簡訊驗證碼

    StateError: { name: 'StateError', path: '/StateError', requiredLogin: false }, // 錯誤訊息畫面
    API_StateErrorViewData: { name: 'API_StateErrorViewData', path: '/api/StateError/ViewData' }, // 錯誤訊息畫面 View Data Api

    // 無補件項目
    NoItem: {
        name: 'NoItem',
        path: '/NoItem',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: null
    },
    // 全部完成
    AllComplete: {
        name: 'AllComplete',
        path: '/AllComplete',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: null
    },
    // 選擇補件業務
    BusinessSelection: {
        name: 'BusinessSelection',
        path: '/BusinessSelection',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: PageNavSteps.BusinessSelection
    },
    API_BusinessSelectionViewData: {
        name: 'API_BusinessSelectionViewData',
        path: '/api/BusinessSelection/ViewData',
        requiredLogin: false,
        leaveProtection: false
    },
    API_BusinessSelectionPostBack: {
        name: 'API_BusinessSelectionPostBack',
        path: '/api/BusinessSelection/PostBack',
        requiredLogin: false,
        leaveProtection: false
    },
    // 檔案上傳
    FileUpload: {
        name: 'FileUpload',
        path: '/FileUpload',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: PageNavSteps.FileUpload
    },
    API_FileUploadViewData: {
        name: 'API_FileUploadViewData',
        path: '/api/FileUpload/ViewData',
        requiredLogin: false,
        leaveProtection: false
    },

    // 更新QR Code
    API_GenerateToken: {
        name: 'API_GenerateToken',
        path: '/api/Token/Generate',
        requiredLogin: false,
        leaveProtection: false
    },

    // 客戶上傳單一檔案 (身分證正面以外的一般文件)
    API_ClientUploadSingleFile: {
        name: 'API_ClientUploadSingleFile',
        path: '/api/Client/UploadSingleFile',
        requiredLogin: false,
        leaveProtection: false
    },

    // 客戶上傳身分證正面文件 (OCR換補領資訊)
    API_ClientUploadIdFrontFile: {
        name: 'API_ClientUploadIdFrontFile',
        path: '/api/Client/UploadIdFrontFile',
        requiredLogin: false,
        leaveProtection: false
    },

    // 圖片預覽 - 透過 DocumentID 取得檔案 Base64
    API_ImagePreview: {
        name: 'API_ImagePreview',
        path: '/api/Image/Preview',
        requiredLogin: false,
        leaveProtection: false
    },

    // 完成上傳
    API_CompleteDocumentCase: {
        name: 'API_CompleteDocumentCase',
        path: '/api/DocumentCase/Complete',
        requiredLogin: false,
        leaveProtection: false
    },

    // 取消上傳中的案件
    API_CancelUploading: {
        name: 'API_CancelUploading',
        path: '/api/DocumentCase/CancelUploading',
        requiredLogin: false,
        leaveProtection: false
    },

    // 刪除已上傳的檔案
    API_DeleteUploadedFile: {
        name: 'API_DeleteUploadedFile',
        path: '/api/FileUpload/DeleteUploadedFile',
        requiredLogin: false,
        leaveProtection: false
    },

    // 集保(TDCC) 取得 TxID
    API_TdccGetTXID: {
        name: 'API_TdccGetTXID',
        path: '/api/Tdcc/GetTXID',
        requiredLogin: false,
        leaveProtection: false
    },

    // 集保(TDCC) 取消授權
    API_TdccRemoveTxID: {
        name: 'API_TdccRemoveTxID',
        path: '/api/Tdcc/RemoveTxID',
        requiredLogin: false,
        leaveProtection: false
    },

    // 補件平台 - 完成補件
    CompleteUploading: {
        name: 'CompleteUploading',
        path: '/CompleteUploading',
        requiredLogin: true,
        leaveProtection: true,
        stepNum: PageNavSteps.Complete
    }
};

/**
 * @todo 取得 route info by url path
 * @param path
 * @returns
 */
const GetRouteDataByUrl = (path: string): IRouteUrlListElement => {
    let targetRouteData = RouteUrlList.StateError;
    for (const key in RouteUrlList) {
        const url: IRouteUrlListElement | null = RouteUrlList[key] || null;

        if (!url) {
            continue;
        }

        const hasMatch: boolean = url.path.toLowerCase().indexOf(path.trim().toLowerCase()) !== -1;
        if (hasMatch) {
            targetRouteData = url;
            break;
        }
    }
    return targetRouteData;
};
export { RouteUrlList, GetRouteDataByUrl };
export type { IRouteUrlListElement, IRouteUrlList };
